import {Component, HostListener, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DESIGN_PREVIEW_MODAL_ID, DESIGN_PREVIEW_STATE} from '@constants/modal-options/modal-options';
import { DAY_IN_MILLIS } from '@constants/pages/user-defined-page/time-constants';
import { BrandingService } from '@services/administration/organization/configuration/branding/branding.service';
import { NotificationService } from '@services/notification/notification.service';
import { StorageService } from '@services/storage/storage.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'scitis-branding-preview-toast',
    templateUrl: './branding-preview-toast.component.html',
    styleUrls: ['./branding-preview-toast.component.scss'],
    standalone: false
})
export class BrandingPreviewToastComponent implements OnInit, OnDestroy {

  constructor(private brandingService: BrandingService, private notificationService: NotificationService, private storageService: StorageService) { }

  @ViewChild('design') design?: TemplateRef<any>;
  @ViewChild('designHeader') designHeader?: TemplateRef<any>;
  @HostListener('window:beforeunload') unloadHandler() {
    this.brandingService.discardDesignPreview();
    this.brandingService.closePreviewToast();
  }
  private destroy$: Subject<boolean> = new Subject<boolean>();


  get organizationName() {
    return this.brandingService.previewOrganizationName;
  }

  ngOnInit(): void {
    this.initSubscription();
    this.setupDesignPreviewToast();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  handleApplyAction(event) {
    this.brandingService.applyDesignPreview();
    this.notificationService.remove(event);
  }

  handleResetAction(event) {
    this.brandingService.discardDesignPreview();
    this.notificationService.remove(event);
  }


  public initSubscription(): void {
    this.notificationService.designPreviewObservable.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.setupDesignPreviewToast();
    });
  }

  private setupDesignPreviewToast() {
    this.storageService.readValueFromIndexedDb(DESIGN_PREVIEW_STATE).then((res) => {
      if (res) {
        this.openDesignPreviewToast();
      }
    });
  }

  private openDesignPreviewToast() {
    this.notificationService.show(
      this.design as TemplateRef<any>,
      this.designHeader as TemplateRef<any>,
      { classname: 'bg-design-preview-toast text-light', delay: DAY_IN_MILLIS, removalFunction: (event) => this.handleResetAction(event), autohide: false, id: DESIGN_PREVIEW_MODAL_ID});
  };

}
